/**
 * @generated SignedSource<<5c329dfdb74b5bf356e6746e32b36fcb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CancelNovaAgentRunInput = {
  id?: string | null;
  runId?: string | null;
  taskId?: string | null;
  agentId?: string | null;
  threadId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type CancelNovaAgentRunMutation$variables = {
  input: CancelNovaAgentRunInput;
};
export type CancelNovaAgentRunMutation$data = {
  readonly cancelNovaAgentRun: {
    readonly run: {
      readonly id: string;
      readonly status: string | null;
      readonly cancelled: boolean | null;
    } | null;
    readonly task: {
      readonly id: string;
      readonly hasNovaConversation: boolean;
      readonly novaRunningRunId: string | null;
    } | null;
  } | null;
};
export type CancelNovaAgentRunMutation = {
  variables: CancelNovaAgentRunMutation$variables;
  response: CancelNovaAgentRunMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CancelNovaAgentRunPayload",
    "kind": "LinkedField",
    "name": "cancelNovaAgentRun",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NovaAgentRun",
        "kind": "LinkedField",
        "name": "run",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cancelled",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Task",
        "kind": "LinkedField",
        "name": "task",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasNovaConversation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "novaRunningRunId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CancelNovaAgentRunMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CancelNovaAgentRunMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "977ea190ff8a0ce910c55b1fd3b639df",
    "id": null,
    "metadata": {},
    "name": "CancelNovaAgentRunMutation",
    "operationKind": "mutation",
    "text": "mutation CancelNovaAgentRunMutation(\n  $input: CancelNovaAgentRunInput!\n) {\n  cancelNovaAgentRun(input: $input) {\n    run {\n      id\n      status\n      cancelled\n    }\n    task {\n      id\n      hasNovaConversation\n      novaRunningRunId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9bb7f27192ce40352af123a27b5d6d23";

export default node;
